declare namespace $ {

	type $mol_button_minor__click_bog_quiz_1 = $mol_type_enforce<
		ReturnType< $bog_quiz['quiz_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_bog_quiz_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_bog_quiz_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_quiz_session_join__session_id_bog_quiz_4 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_quiz_session_join['session_id'] >
	>
	type $bog_quiz_session_play__session_id_bog_quiz_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_quiz_session_play['session_id'] >
	>
	export class $bog_quiz extends $mol_book2_catalog {
		Realm( ): $giper_baza_glob
		quiz_add( next?: any ): any
		Quiz_add_icon( ): $mol_icon_plus
		Quiz_add( ): $mol_button_minor
		Theme( ): $mol_theme_auto
		Quiz_spread( id: any): $mol_view
		param( ): string
		realm( ): ReturnType< $bog_quiz['Realm'] >
		menu_title( ): string
		menu_tools( ): readonly(any)[]
		plugins( ): readonly(any)[]
		Placeholder( ): any
		spreads( ): Record<string, any>
		Spread( id: any): ReturnType< $bog_quiz['Quiz_spread'] >
		Join_page( ): $bog_quiz_session_join
		Play_page( ): $bog_quiz_session_play
	}
	
}

//# sourceMappingURL=quiz.view.tree.d.ts.map